import React from 'react';
import styled from 'styled-components';

import ColorSwatch from './ColorSwatch';

const ColorSwatches = ({ numberOfSwatches, selectSwatch, activeSwatch, showAll, hidePicker, totalNumberOfSwatches }) => {
    const StyledBox = styled.div`
        margin: 0 ${props => props.theme.space[3]} ${
        props => props.theme.space[7]} 0;
        padding: 0;
        width: ${props => props.theme.space[16]};
        flex-grow: 1;
    `;

    const buildColorSwatchItem = x => {
        const Boxes = [];
        for (let i = 0; i < x; i++) {
            Boxes[i] = (<StyledBox key={i}>
                <ColorSwatch
                    id={i} key={i}
                    onClickSelected={hidePicker}
                    onClick={selectSwatch}
                />
            </StyledBox>);
        }
        return Boxes;
    };

    const SwatchWrapper = styled.div`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    `;

    const Swatches = buildColorSwatchItem(numberOfSwatches);

    return (
        <div>
            <SwatchWrapper>
                {Swatches}
            </SwatchWrapper>
        </div>
    );
};

export default ColorSwatches;



// WEBPACK FOOTER //
// ./src/components/recoloring/ColorSwatches.js